import type { AppProduct } from "@shared/interfaces/product";
import { ProductType } from "@shared/interfaces/product";

export const calculateQuantityForAppProduct = (product: AppProduct, moduleCount: number, kwPerYearAndModule: number) => {
    switch (product.type) {
        case ProductType.SOLAR_PANEL:
            return moduleCount;
        case ProductType.INVERTER:
            if (product.scalingRules && product.scalingRules.scalingRules && product.scalingRules.scalingRules.length > 0) {
                return 1;
            }

            if (!product.powerClass || product.powerClass <= 0) {
                return 1;
            }

            return Math.max(Math.ceil((kwPerYearAndModule * moduleCount) / product.powerClass), 1);
        case ProductType.BATTERY_STORAGE:
            if (product.scalingRules && product.scalingRules.scalingRules && product.scalingRules.scalingRules.length > 0) {
                return 1;
            }

            if (!product.powerClass || product.powerClass <= 0) {
                return 1;
            }

            return Math.max(Math.ceil((kwPerYearAndModule * moduleCount) / product.powerClass), 1);
        default:
            return 1;

    }
}

export const calculateScalingValues = (product: AppProduct, pvSize: number) => {
    switch (product.type) {
        case ProductType.BATTERY_STORAGE:
        case ProductType.INVERTER:
                if (product.scalingRules && product.scalingRules.scalingRules && product.scalingRules.scalingRules.length > 0) {
                    return product.scalingRules.scalingRules.find(rule => rule.maxPeak >= pvSize && rule.minPeak <= pvSize)!;
                }
            break;
    }
}
